import React from 'react';
import { CommentsSectionLoader } from '@confluence-classic/confluence-utils/entry-points/CommentsSectionLoader.ts';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { ViewPagePdfExportLoader } from '@confluence/pdf-export';

import { ContentExtensionsProvider } from '../../ContentExtensionsProvider/index.ts';
import SpaceBase from '../../SpaceBase/index.js';

export const PdfExportPageRoute: {
	({ params: { contentId, spaceKey } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ name, params: { contentId, spaceKey } }: RouteMatch): {
		Screen: {
			pageState: {
				contentId: string;
				routeName: string;
				spaceKey: string;
			};
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			enableNavigation: boolean;
			spaceKey: string;
		};
	};
} = ({ params: { contentId, spaceKey } }: RouteMatch): React.JSX.Element => (
	<SpaceBase>
		<ContentExtensionsProvider>
			<ViewPagePdfExportLoader
				contentId={String(contentId)}
				spaceKey={String(spaceKey)}
				classicComments={CommentsSectionLoader}
			/>
		</ContentExtensionsProvider>
	</SpaceBase>
);

PdfExportPageRoute.NAVIGATION_PARAMS = ({
	name,
	params: { contentId, spaceKey },
}: RouteMatch): {
	Screen: {
		pageState: {
			contentId: string;
			routeName: string;
			spaceKey: string;
		};
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		enableNavigation: boolean;
		spaceKey: string;
	};
} => ({
	Screen: {
		pageState: {
			contentId,
			routeName: name,
			spaceKey,
		},
		screenEvent: { name: 'pdfExportScreen' },
	},
	MainLayout: {
		enableNavigation: false,
		spaceKey,
	},
});
